module.exports = __webpack_public_path__ + "img/zain-logo-black3.c4f81ffe.png";